import React from "react";
import PageHero from "../components/PageHero";
import { Trophy, Music, Dumbbell, Gamepad2, Coffee, Palette } from "lucide-react";

const blocks = [
  {
    icon: Trophy,
    title: "Sports & Athletics",
    body: "For those who enjoy a sporty lifestyle, a year-round sport & athletics calendar awaits you. This gets especially competitive over the autumn/winter months.",
    items: ["Cricket", "Football", "Ultimate Frisbee", "Kho Kho", "Chess", "Kabaddi", "Badminton"],
    note: "An inter-house sports and athletics meet rounds off the annual calendar, with highly competitive races and the Ultimate Kiki Soap Box race.",
  },
  {
    icon: Palette,
    title: "Social & Cultural",
    body: "The social and cultural calendar runs through the summer months. Various events are held such as:",
    items: ["Music", "Quiz", "Debate", "Talent Show", "Art, Craft & Sculpture Show", "Art & Technology Competition", "Bollywood Night"],
    note: "Increasingly popular are the movie nights organized by students themselves.",
  },
  {
    icon: Dumbbell,
    title: "In-house Gym",
    body: "To energize your day, a well-equipped gym is available with:",
    items: ["Treadmill", "Cross-Trainer", "Cycling", "Weights"],
  },
  {
    icon: Gamepad2,
    title: "Other Sports Facilities",
    body: "Students make the most of in-house sports facilities during breaks.",
    items: ["Table Tennis", "Carom", "Pool"],
  },
  {
    icon: Music,
    title: "Music Room",
    body: "For the more musically inclined, the music room offers a great place to spend your free time. Play the keyboard, guitar and other instruments.",
    items: [],
  },
  {
    icon: Coffee,
    title: "Café",
    body: "A café welcomes hungry students. Enjoy sitting in the café eating lunch or tucking into your favourite snacks.",
    items: [],
  },
];

export default function ActivitiesPage() {
  return (
    <div data-testid="activities-page">
      <PageHero
        path="activities.hero"
        kicker="Student Life"
        title="Activities at Kiki"
        subtitle="Lots of activities are woven into daily life to enhance students' mental and physical fitness and ensure all-round growth."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
          {blocks.map((b) => (
            <div key={b.title} className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-12 w-12 rounded-xl bg-yellow-400/15 flex items-center justify-center">
                  <b.icon className="h-6 w-6 text-yellow-600" />
                </div>
                <h3 className="text-xl font-bold text-[#0B2A6B]">{b.title}</h3>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{b.body}</p>
              {b.items.length > 0 && (
                <div className="mt-4 flex flex-wrap gap-2">
                  {b.items.map((it) => (
                    <span key={it} className="px-3 py-1 rounded-full bg-slate-100 text-slate-700 text-xs font-semibold">
                      {it}
                    </span>
                  ))}
                </div>
              )}
              {b.note && <p className="mt-4 text-sm text-slate-500 italic">{b.note}</p>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
